export const breakpoints = {
    mobile: 1023,
}